import labels from "../../../constants/displayFields";
import { useProject } from "../../../contexts/project";
import useAuth from "../../../hooks/useAuth";

const section = "origin";

const ORIGIN_STRING_FIELDS = [
  ["existing_building", "existingBuilding"],
  ["existing_room", "existingRoom"],
  ["existing_floor", "existingFloor"],
  ["origin_room_number", "originRoomNumber"],
  ["origin_employee_name", "originEmployeeName"],
  ["origin_comments", "originComments"],
  ["origin_cubby_number", "originCubbyNumber"],
  ["department_name", "departmentName"],
];

export default function useEnabledOrigin({ display, disabledForm, asset }) {
  const currentProject = useProject();
  const { user } = useAuth();
  const onsiteInventoryCapture = currentProject?.settings?.onsite_inventory_capture;
  const availableQuantityLabel = user.company.settings.quantity_label || labels.available_quantity;

  const fields = [
    ...ORIGIN_STRING_FIELDS.map(([id, name]) => ({
      id,
      enabled: display[id],
      type: "input",
      section,
      gridProps: { sm: 12 },
      params: {
        type: "autoExpand",
        name,
        label: labels[id],
        disabled: disabledForm,
      },
    })),
    {
      id: "quantity",
      enabled: display.quantity,
      type: "origin_quantity",
      section,
      gridProps: { sm: 12 },
      params: {
        disabled: disabledForm,
        showAvailableQuantity: Boolean(display.quantity && onsiteInventoryCapture),
        availableQuantityLabel,
        availableQuantityValue: asset?.availableQuantity ?? asset?.available_quantity,
      },
    },
  ].filter(field => field.enabled);

  return fields;
}
